<ft-modal-overlay [open]="open()">
    @if (open()) {
        <ft-modal-chrome-ng
            modalClass="cancelReservationModal"
            [headerText]="'flipto.account.people.details.RemoveGuestDetails' | translate"
            [headerDescription]="'flipto.account.people.details.RemoveDescription' | translate"
            size="sm"
            doneText="Delete"
            [doneVisible]="true"
            [cancelVisible]="false"
            [footerVisible]="true"
            [footerCancelVisible]="true"
            (done)="remove()"
            (cancel)="cancel()"
        >
            <div class="modal-section-heading">{{ 'flipto.account.people.details.ReasonHeading' | translate }}</div>
            <div class="modal-panel modal-panel-input">
                <ft-select-ng
                    [items]="deleteReasons"
                    value="value"
                    key="value"
                    [(selectedKey)]="reasonDeleted"
                    [placeholder]="'flipto.account.people.details.SelectAReason' | translate"
                />
            </div>
        </ft-modal-chrome-ng>
    }
</ft-modal-overlay>
